import type { ReactNode, RefObject } from 'react';
import type { FacetsResponse } from '@/api/client';
import type { Zone } from '@/lib/format';
import type { TimeRange } from '@/lib/time';
import { Icon } from './Icon';
import { QueryBar } from './QueryBar';
import { RangePicker } from './RangePicker';

export interface QueryRowProps {
    // The saved views' menu, beside the query.
    views: ReactNode;
    envs: readonly string[];
    input: string;
    onInput: (q: string) => void;
    onRun: (q: string) => void;
    error: string | null;
    facets: FacetsResponse | undefined;
    scope: { env: string; from: number; to: number };
    recent: readonly string[];
    range: TimeRange;
    anchor: number;
    zone: Zone;
    rangeOpen: boolean;
    onRangeOpen: (open: boolean) => void;
    onRange: (range: TimeRange) => void;
    onShare: () => void;
    // A new alert rule on what is on screen.
    onAlert: () => void;
    inputRef: RefObject<HTMLInputElement | null>;
}

// The row under the top bar: what to look for and when, in one bar; the saved views, the link to it and an alert on it
// beside it. The environment is the top bar's; live is the list's own (D-22).
export function QueryRow(props: QueryRowProps): ReactNode {
    return (
        <div className="queryrow">
            <QueryBar
                input={props.input}
                onInput={props.onInput}
                onRun={props.onRun}
                error={props.error}
                facets={props.facets}
                scope={props.scope}
                envs={props.envs}
                recent={props.recent}
                inputRef={props.inputRef}
                trailing={
                    <RangePicker
                        range={props.range}
                        anchor={props.anchor}
                        zone={props.zone}
                        open={props.rangeOpen}
                        onOpen={props.onRangeOpen}
                        onRange={props.onRange}
                    />
                }
            />
            {props.views}
            <button className="ghost square tool" onClick={props.onShare} title="Copy a link to this view, its time fixed">
                <Icon name="link" size={18} />
            </button>
            <button className="ghost square tool" onClick={props.onAlert} title="Alert on this query: a new rule, filled in">
                <Icon name="bell" size={18} />
            </button>
        </div>
    );
}
